import React from 'react'
import { t } from '@lingui/macro'
import { useLocalStore } from 'mobx-react-lite'
import { _ } from '../../utils/intl'
import { ReachConfirmDialog } from '../modals/ConfirmModal'
import { CardsStore } from '../../../end-user/dashboard/CardsStore'
import { ApiCardsRepository } from '../../api/ApiCardsRepository'

export const ActivateDeactivateCardModal: React.SFC<{
  cards: CardsStore
  type: 'activate' | 'deactivate' | 'block'
  close: () => void
}> = ({ cards, type, close }) => {
  const state = useLocalStore(() => ({
    saving: false,
  }))

  const modalProps = {
    title: _(t`Aktivácia karty`),
    message: _(t`Naozaj chcete Vašu kartu aktivovať?`),
    buttonConfirmText: _(t`Aktivovať`),
  }

  if (type === 'deactivate' || type === 'block') {
    modalProps.title = _(t`Deaktivácia karty`)
    modalProps.message = _(t`Naozaj chcete Vašu kartu deaktivovať?`)
    modalProps.buttonConfirmText = _(t`Deaktivovať`)
  }

  return (
    <ReachConfirmDialog
      close={close}
      buttonCancelText={_(t`Zatvoriť`)}
      disabledConfirmButton={state.saving}
      buttonConfirmAction={async () => {
        state.saving = true
        if (type === 'activate') {
          await ApiCardsRepository.activateCard(cards.selectedCardId!)
        } else if (type === 'deactivate') {
          await ApiCardsRepository.deactivateCard(cards.selectedCardId!)
        } else if (type === 'block') {
          await ApiCardsRepository.blockCard(cards.selectedCardId!)
        }
        state.saving = false
        cards.fetchEmpoyeeCards()
        close()
      }}
      {...modalProps}
    />
  )
}
